<p *ngIf="noResultsFlag" style="color: #6c757d; font-size: .875rem;" class="text-muted"><strong>{{currLang=== 'en' ? 'No Results Found' : 'لا توجد بيانات'}}</strong></p>
<div  class='container'>
  <div class='row controllers-btns-container'>
    <div class='col-10 controller-container' style="padding: 0px;">
      <app-controller-bar (messagesSearchChange)='searchInMessages($event)'
        (onChangedItemsPerPage)='setItemsPerPage($event)' (onViewTypeChange)='setViewType($event)'></app-controller-bar>
    </div>
    <div class="col-2 actions-btns-container">
      <div class="create-message-btn" [routerLink]='["/messages/create-messages"]'>
        <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.5 1.5H14.5C15.0523 1.5 15.5 1.94772 15.5 2.5V10.5C15.5 11.0523 15.0523 11.5 14.5 11.5H1.5C0.947715 11.5 0.5 11.0523 0.5 10.5V2.5C0.5 1.94772 0.947715 1.5 1.5 1.5Z" stroke="white" stroke-width="1.1"/>
          <path d="M1 2L8 7.5L15 2" stroke="white" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>{{ 'messages.create-msg.header' | translate }}</span>
      </div>
    </div>
  </div>
  <div *ngIf="!noResultsFlag" class='row messages-list-container'>
    <div class="col-12 no-gutters" style='padding:0 !important'>
      <app-view-message-list *ngIf='viewType=="list"' (onScrollList)='onScrollList($event)'
        (onSortList)='sortTable($event)' [currentMessage]='currentMessage' [messagesList]='messagesList'>
      </app-view-message-list>
      <div [hidden]='viewType != "compact"'>

        <div *ngIf='messagesFacade.isLoading' class="loading">
          <mat-spinner *ngIf="true" mode="indeterminate"></mat-spinner>
        </div>
        <ng-container >
          <app-messages-compact-view [paginatorInfo]='paginatorInfo' (onPaginationBtnClick)='paginationHandler($event)'
            (onSortingTable)='sortTable($event)' [messagesList]='messagesCompact'></app-messages-compact-view>
        </ng-container>
        <!-- <div style='height: 100%;' *ngIf='messagesFacade.isLoading'
          class='loading d-flex justify-content-center align-items-center'>
          <div class='d-flex justify-content-center'>
            <mat-spinner [diameter]="70" mode="indeterminate"></mat-spinner>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>